import React from 'react';
import { Palette, Paintbrush } from 'lucide-react';
import { cn } from '@/lib/utils';

type TabType = 'background' | 'theme';

type TabNavigationProps = {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  onColorPickerChange: (picker: 'background' | 'ui') => void;
};

export const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
  onColorPickerChange
}) => (
  <div className="flex border-b border-zinc-700 w-full">
    <button
      onClick={() => {
        onTabChange('background');
        onColorPickerChange('background');
      }}
      className={cn(
        "flex-1 p-3 text-xs font-medium transition-colors",
        activeTab === 'background'
          ? "text-white border-b-2 border-[rgb(var(--accent-1))]"
          : "text-zinc-400 hover:text-zinc-300"
      )}
    >
      <Palette className="h-4 w-4 inline mr-1" />
      Background
    </button>
    <button
      onClick={() => {
        onTabChange('theme');
        onColorPickerChange('ui');
      }}
      className={cn(
        "flex-1 p-3 text-xs font-medium transition-colors",
        activeTab === 'theme'
          ? "text-white border-b-2 border-[rgb(var(--accent-1))]"
          : "text-zinc-400 hover:text-zinc-300"
      )}
    >
      <Paintbrush className="h-4 w-4 inline mr-1" />
      Theme
    </button>
  </div>
);